// const baseUrl = 'https://sdpcallback.ndotomedia.com'
// const baseUrl=`http://localhost:5090`
const baseUrl=''

export { baseUrl }